export default class Utils {
  

  static arrayToCsvString(arr) {
    var str = ''
    arr.forEach((arr2) => {
      str += arr2.map((el) => {
        return `"${('' + el).replace(/"/g, '\\"')}"`
      }).join(',') + '\n'
    })
    return str
  }

  static makeCancelablePromise(promise) {
    let hasCanceled_ = false
    const wrappedPromise = new Promise((resolve, reject) => {
      promise.then((val) =>
        hasCanceled_ ? reject({isCanceled: true}) : resolve(val)
      )
      promise.catch((error) =>
        hasCanceled_ ? reject({isCanceled: true}) : reject(error)
      )
    })
    return {
      promise: wrappedPromise,
      cancel() {
        hasCanceled_ = true
      }
    }
  }
  
}